export default "__VITE_ASSET__DGFuB9gU__"